import React from 'react';
import { useTheme } from '../../../assets/contexts/ThemeContext';
import CustomSelect from '../../../components/widgets/CustomSelect';

/**
 * 메가메뉴 스타일 유형 제어 컴포넌트
 */
const MegaMenuStyleControl = () => {
  const themeContext = useTheme();
  if (!themeContext) return null;
  const { themeConfig, set } = themeContext;

  return (
    <div id="mega-menu-style-control-section" style={{ marginBottom: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
        <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px', margin: 0, flex: 1 }}>
          🎨 메가메뉴 스타일 유형:
        </label>
        <button
          type="button"
          className="theme-help-btn"
          data-target="mega-menu-style-control-section"
          title="이 항목으로 이동"
          style={{
            background: 'transparent',
            border: '1px solid #ddd',
            color: '#666',
            fontSize: '11px',
            width: '20px',
            height: '20px',
            padding: 0,
            borderRadius: '50%',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#f5f5f5';
            e.target.style.borderColor = 'var(--theme-color-primary)';
            e.target.style.color = 'var(--theme-color-primary)';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.borderColor = '#ddd';
            e.target.style.color = '#666';
          }}
        >
          ?
        </button>
      </div>
      <CustomSelect
        value={themeConfig.megaMenuStyle || 'default'}
        onChange={(v) => set('megaMenuStyle', v)}
        isSearchable={false}
        isClearable={false}
        options={[
          { value: 'default', label: '기본 스타일' },
          { value: 'glow', label: 'Glow 스타일' },
        ]}
        styles={{
          control: (base, state) => ({
            ...base,
            width: '100%',
            minHeight: 36,
            fontSize: 13,
            borderRadius: 4,
            borderColor: state.isFocused ? '#86b7fe' : '#ddd',
          }),
          valueContainer: (base) => ({ ...base, padding: '0 10px' }),
          indicatorsContainer: (base) => ({ ...base, height: 36 }),
        }}
      />
      <div style={{ fontSize: '11px', color: '#999', marginTop: '6px' }}>
        메가메뉴 드롭다운의 스타일 유형을 선택합니다.
      </div>
    </div>
  );
};

export default MegaMenuStyleControl;

